<template>
    <div>
        <el-tabs v-model="tabsKey" type="card" @tab-click="handleClick">
            <el-tab-pane label="查詢店櫃" name="search" >
                <Search @addTabs="addShopTabs" @detailTabs="ShopDetailTabs" />
            </el-tab-pane>
            <el-tab-pane label="增加" name="add" v-if="isShowAdd" >
                <Add @back="removeShopTabs"  />
            </el-tab-pane>
            <el-tab-pane label="詳細" name="detail" v-if="isShowDetail" >
                <Detail :shopKey="shopKey" @back="removeDetailTabs" @editTabs="shopEditTabs" />
            </el-tab-pane>
            <el-tab-pane label="編輯" name="edit" v-if="isShowEdit" >
                <Edit :shopKey="shopKey" @back="removeEditTabs" @removeEdit="removeEditTabs" />
            </el-tab-pane>
        </el-tabs>
        
    </div>
</template>

<script>
import Search from './Shop/Search'
import Add from './Shop/Add'
import Detail from './Shop/Detail'
import Edit from './Shop/Edit'
    export default {
        name: 'Shop',
        data() {
            return {
                   tabsKey: 'search',
                isShowAdd: false,
                isShowDetail: false,
                isShowEdit: false,
                shopKey: ''
            }
        },
        components: {
            Search,
            Add,
            Edit,
            Detail
        },
        methods: {
              addShopTabs: function(){
          this.isShowAdd = true
          this.tabsKey = 'add'
      },
      removeShopTabs: function(){
          this.isShowAdd = false
          this.tabsKey = 'search'
      },
      ShopDetailTabs: function(shopKey){
         this.shopKey = shopKey
          this.isShowDetail = true
          this.tabsKey = 'detail'
      },
      removeDetailTabs: function(){
          this.isShowDetail = false
          this.tabsKey = 'search'
      },
      shopEditTabs: function(shopKey){
          this.shopKey = shopKey
          this.isShowDetail = false
          this.isShowEdit = true
          this.tabsKey = 'edit'
      },
      removeEditTabs: function(){
          this.isShowEdit = false
          this.tabsKey = 'search'
      },
       handleClick(tab, event){
          if (tab.name == 'search') {
              this.removeEditTabs()
              this.removeShopTabs()
              this.removeDetailTabs()
          }
      }
        },
    }
</script>

<style  scoped>
    
</style>